let routes = [];

if (window.sessionStorage.VUE_NAVIGATION) {
    routes = JSON.parse(window.sessionStorage.VUE_NAVIGATION);
}

export default routes;
